<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <div>
          <v-switch
            v-model="computedValue.show"
            class="ma-0"
            inset
            :label="$t('display')"
          />
        </div>

        <v-card :disabled="!computedValue.show" flat>
          <v-row juctify="center" no-gutters>
            <v-col class="pa-2" cols="12" md="6" order="0">
              <div class="rowinfo">
                <v-text-field
                  v-model="computedValue.title"
                  dense
                  :label="$t('extraSubProducts.name_label')"
                  outlined
                />
                <help-info
                  left
                  :element-name="`${serviceName}-${componentName}-valueComputed-title`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('extraSubProducts.name_label')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="6" order="1">
              <!--        <v-text-field outlined dense label="آدرس" v-model="computedValue.link"/>-->
              <div class="rowinfo">
                <IconPicker v-model="computedValue.icon" class="contentinfo" />
                <help-info
                  left
                  :element-name="`${serviceName}-${componentName}-valueComputed-icon`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('icon')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="6" order="2">
              <color-picker
                v-model="computedValue.color"
                :label="$t('color')"
                size="100%"
              />
            </v-col>

            <v-col class="pa-2" cols="12" md="6" order="3">
              <div class="rowinfo">
                <v-text-field
                  v-model="computedValue.link"
                  dense
                  :label="$t('link')"
                  outlined
                />
                <help-info
                  left
                  :element-name="`${serviceName}-${componentName}-valueComputed-link`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('link')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" md="6" order="5" order-md="4">
              <div class="rowinfo">
                <v-btn :style="style">
                  <v-icon v-if="computedValue.icon" left>{{
                    computedValue.icon
                  }}</v-icon>
                  {{ computedValue.title }}
                </v-btn>
                <help-info
                  left
                  :element-name="`${serviceName}-${componentName}-valueComputed-title`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('title')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" order="4" order-md="5">
              <color-pallete v-model="computedValue.background" />
            </v-col>
          </v-row>
        </v-card>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import IconPicker from "@/view/components/IconPicker";
import ColorPicker from "@/view/pages/qrland/components/colorPicker";
import ColorPallete from "@/view/components/colorPallete";

export default {
  name: "CallToAction",

  components: { ColorPallete, ColorPicker, IconPicker },

  props: {
    value: Object,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "call-to-action",
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    style() {
      return {
        background: this.computedValue.background,
        color: this.computedValue.color,
      };
    },
  },
};
</script>

<style scoped>
.rpBtn {
  background: var(--bg) !important;
  color: var(--color) !important;
}
</style>
